module.exports = __webpack_public_path__ + "static/img/word.ea6917d4.svg";